const SYSTEMS = ['workspace', 'cases', 'sessions', 'reports', 'execution', 'finance', 'automation', 'followup'];

export function isTrainingHost(hostname = globalThis.location?.hostname || '') {
  return hostname === 'n9-training.n9-law-system.workers.dev'
    || SYSTEMS.some(system => hostname === `n9-training-${system}.n9-law-system.workers.dev`);
}

export function systemOrigin(system, configured) {
  if (!SYSTEMS.includes(system)) throw new Error('Unknown connected system');
  if (isTrainingHost()) return `https://n9-training${system === 'workspace' ? '' : `-${system}`}.n9-law-system.workers.dev`;
  return configured || `https://n9-${system === 'workspace' ? 'law-workspace' : system}.n9-law-system.workers.dev`;
}
